/**
 * @title 直播间页面接口
 * @date 2020-11-24
 */
export class IGetMeetingLive {
  m: string = "";
}


export class IGetAPIProgram {
  m: string = "";
  dateid?: number = 0;
  roomid?: number = 0;
  search?: string = "";
}

export class IGetGetPhotoClass {
  m: string = "";
}
export class IGetPhotoInfo {
  m: string = "";
  clid: string = "";
}
export class IGetPhotoPageInfo {
  m: string = "";
  clid: string = "";
  page: string = "";
}